import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  constructor(private readonly http: HttpClient) {}

  public checkMaintenanceWorks(): Observable<{ maintenance: boolean }> {
    return this.http.get<{ maintenance: boolean }>(`${environment.apiEndpoint}/b2b/maintenance`);
  }
}
